exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".listAreaContent[data-v-a23743f8] {\n  width: 100%;\n  min-height: 200px;\n  overflow: hidden;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 15px 0 15px 3px;\n}\n.listAreaContent .likeAvatarItem[data-v-a23743f8] {\n  width: 40px;\n  height: 40px;\n  display: inline-block;\n  margin: 0 6px 8px 0;\n}\n", ""]);

// exports
